import type { PropsWithChildren } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { isAuthenticated, isPlatformAdmin, signOut } from '@shared/auth/cognito';

export default function RequireAuth({ children }: PropsWithChildren) {
  const location = useLocation();

  if (!isAuthenticated()) {
    const returnTo = `${location.pathname}${location.search}${location.hash}` || '/';
    return <Navigate to="/login" replace state={{ returnTo }} />;
  }

  if (!isPlatformAdmin()) {
    return (
      <div className="auth-page">
        <article className="auth-card">
          <div className="brand auth-brand">
            <div className="brand-mark">S</div>
            <div>
              <div className="brand-title">SURELINC</div>
              <div className="brand-subtitle">Admin Portal</div>
            </div>
          </div>
          <h1>Access denied</h1>
          <p>This account is not authorized to access the SURELINC admin portal.</p>
          <button className="primary-button" type="button" onClick={() => signOut()}>
            Sign out
          </button>
        </article>
      </div>
    );
  }

  return <>{children}</>;
}
